import './styles.scss'
import Ad from './components/Ad'
import React from 'react'
import ReactDOM from 'react-dom/client'
import Card from './components/Card'
import CardHover from './components/CardHover'
import Deck from './components/Deck'
import Debug from './components/Debug'
import { Provider } from 'react-redux'
import UserButton from './components/UserButton'
import UserModal from './components/UserModal'
import { debugEnabled } from './util'
import { faSignIn, faSpinner, faUser } from '@fortawesome/free-solid-svg-icons'
import firebase from 'firebase/compat/app'
import 'firebase/compat/auth'
import 'firebase/compat/firestore'
import { library } from '@fortawesome/fontawesome-svg-core'
import { store } from './store/store'
import { v4 } from 'uuid'
import { ReactReduxFirebaseProvider } from 'react-redux-firebase'
import { createFirestoreInstance } from 'redux-firestore'

if (firebase.apps.length === 0) {
  const firebaseConfig = {
    apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
    appId: process.env.REACT_APP_FIREBASE_APP_ID,
    authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
    databaseURL: process.env.REACT_APP_FIREBASE_DATABASE_URL,
    measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
    messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
    projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
    storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  }
  firebase.initializeApp(firebaseConfig)
  firebase.firestore()
}

const rrfProps = {
  config: {
    preserveOnLogin: { profile: true },
    useFirestoreForProfile: true,
    userProfile: 'users',
  },
  createFirestoreInstance,
  dispatch: store.dispatch,
  firebase,
}

library.add(faSignIn, faSpinner, faUser)

const options = (elem) => {
  return {
    onlyBack: elem.parentNode.classList.contains('only-back'),
    onlyFront: elem.parentNode.classList.contains('only-front'),
    reverse: elem.parentNode.classList.contains('reverse'),
    sideBySide: elem.parentNode.classList.contains('side-by-side'),
    rotate: elem.parentNode.classList.contains('rotate'),
  }
}

const formatName = (name) => {
  return name.replace('★', 'star').replace('†', 'dagger').replace('Φ', 'phi')
}

// [ec]
const cardElems = document.getElementsByClassName('edhrecp__cards')
;[...cardElems].forEach((parentElem) => {
  ReactDOM.createRoot(parentElem).render(
    <Provider store={store}>
      {[...parentElem.children]
        .filter((elem) => elem.className === 'edhrecp__card-container')
        .map((elem) => (
          <Card
            key={v4()}
            name={formatName(elem.getAttribute('name'))}
            tag='ec'
            {...options(elem)}
          />
        ))}
    </Provider>
  )
})

// [ed]
const deckElems = document.getElementsByClassName('edhrecp__deck')
;[...deckElems].forEach((parentElem) => {
  ReactDOM.createRoot(parentElem).render(
    <Provider store={store}>
      {[...parentElem.children]
      .filter((elem) => elem.className === 'edhrecp__deck-s')
      .map((elem) => (
        <Deck key={v4()} value={elem.getAttribute('cards')} title={elem.getAttribute('name')} archidekt_link={elem.getAttribute('archidekt_link')} site={elem.getAttribute('site')}/>
      ))}
    </Provider>
  )
})

// [el]
const linkElems = document.getElementsByClassName('edhrecp__link')
;[...linkElems].forEach((parentElem) => {
  ReactDOM.createRoot(parentElem).render(
    <Provider store={store}>
      {[...parentElem.children]
        .filter((elem) => elem.className === 'edhrecp__link-a')
        .map((elem) => (
          <CardHover
            key={v4()}
            name={elem.getAttribute('content') ? formatName(elem.getAttribute('content')) : formatName(elem.textContent)}
            tag='el'
            {...options(elem)}
          >
            {elem.textContent}
          </CardHover>
        ))}
    </Provider>
  )
})

// users
{
  const userButton = document.getElementById('user-button')
  if (userButton) {
    ReactDOM.createRoot(userButton).render(
      <Provider store={store}>
        <UserButton />
      </Provider>
    )
  } else {
    console.log('Missing #user-button')
  }

  const userModal = document.getElementById('user-modal')
  if (userModal) {
    ReactDOM.createRoot(userModal).render(
      <Provider store={store}>
        <ReactReduxFirebaseProvider {...rrfProps}>
          <UserModal />
        </ReactReduxFirebaseProvider>
      </Provider>
    )
  } else {
    console.log('Missing #user-modal')
  }
}

// debug
if (debugEnabled()) {
  const elem = document.getElementsByClassName('debug-messages')[0]
  if (elem) {
    ReactDOM.createRoot(elem).render(
      <Provider store={store}>
        <Debug />
      </Provider>
    )
  }
}

// mediavine
const adElem = document.getElementById('mv')
if (adElem) {
  ReactDOM.createRoot(adElem).render(
    <Provider store={store}>
      <Ad />
    </Provider>
  )
} else {
  console.log('Missing #mv')
}
